import { HttpContextToken } from '@angular/common/http';

export enum ApiScope {
  ORDER = 'ORDER',
  COMPANY = 'COMPANY',
  USER = 'USER',
}

export enum ApiAction {
  READ = 'READ',
  WRITE = 'WRITE',
}

export enum ApiWriteActionType {
  TRANSITION = 'TRANSITION',
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
}

export const API_ACTION = new HttpContextToken<ApiAction>(() => ApiAction.READ);
export const API_SCOPE = new HttpContextToken<ApiScope | null>(() => null);
export const API_WRITE_ACTION_TYPE = new HttpContextToken<ApiWriteActionType | null>(
  () => ApiWriteActionType.TRANSITION
);
